module.exports = __webpack_public_path__ + "img/home-video-placeholder.047ad4bd.png";